import { useStores } from "../../stores/root-store";
import { observer } from "mobx-react";
import _ from "lodash";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import { ApiResponse, IModal } from "../../stores";
import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { ShowAlert } from "../../utils/functions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import { IProductCategory } from "../../stores/products";

const CategoryForm = observer(({ show, setShowModal }: IModal) => {
  const { categoryStore } = useStores();
  const { editCategory, fetchCategories, saveCategory } = categoryStore;
  const [category, setCategory] = useState<IProductCategory>(
    editCategory ?? {
      id: 0,
      name: "",
    }
  );
  const [isFormValid, setIsFormValid] = useState(true);
  const isEditRequest = editCategory != null && editCategory.id > 0;

  const validateForm = () => {
    const isValid = category.name ? true : false;
    setIsFormValid(isValid);
  };

  useEffect(() => {
    validateForm();
  }, [category]);

  const submitCallback = useCallback((res: ApiResponse<number>) => {
    if (res?.isSuccess && res?.data > 0) {
      setShowModal(false);
      fetchCategories();
      ShowAlert.Success(
        `Category ${isEditRequest ? "updated" : "added"} successfully.`
      );
    } else {
      ShowAlert.Error(res.message ?? "Request failed. Please try again.");
    }
  }, []);

  const handleFormSubmit = () => {
    if (!isFormValid) {
      ShowAlert.Error("One or more field value missing.");
      return;
    }

    saveCategory(category, submitCallback);
  };

  const handleInputChange = (evt: ChangeEvent<HTMLInputElement>) => {
    const { id, value } = evt.target;
    setCategory((prev) => ({ ...prev, [id]: value }));
  };

  return (
    <Modal show={show} onHide={() => setShowModal(false)}>
      <ModalHeader closeButton>
        <Modal.Title>
          <h5>{isEditRequest ? "Update" : "Add"} Category</h5>
        </Modal.Title>
      </ModalHeader>
      <ModalBody>
        <form>
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              id="name"
              placeholder="Category Name"
              value={category.name}
              required
              onChange={handleInputChange}
            />
            <label htmlFor="CategoryName">Category Name</label>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-default flex-fill"
          onClick={handleFormSubmit}
          disabled={!isFormValid}
        >
          {isEditRequest ? (
            <>
              <FontAwesomeIcon icon={faEdit} className="me-2" />
              <span>Update</span>
            </>
          ) : (
            <>
              <FontAwesomeIcon icon={faPlus} className="me-2" />
              <span>Add</span>
            </>
          )}
        </button>
      </ModalFooter>
    </Modal>
  );
});

export default CategoryForm;
